/* Bazar91 Air Reviews: jump to the actual native app section. */
(function(){
 if(window.__b91ReviewJumpBound)return;
 window.__b91ReviewJumpBound=true;
 function getNative(){
  var a=document.getElementById('b91-air-app-reviews');if(a)return a;
  var s=document.querySelector('[id*="__1776255282990becd7"]');if(s)return s;
  var blocks=document.querySelectorAll('[id^="shopify-section-"]');
  for(var i=0;i<blocks.length;i++)if(blocks[i].id.indexOf('1776255282990becd7')>=0)return blocks[i];
  return null;
 }
 document.addEventListener('click',function(e){
  var link=e.target.closest('a[data-b91-reviews-jump],a[href="#b91-air-app-reviews"]');if(!link)return;
  var native=getNative();if(!native)return;
  e.preventDefault();
  native.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
  native.setAttribute('tabindex','-1');native.focus({preventScroll:true});
  if(history.replaceState)history.replaceState(null,'','#b91-air-app-reviews');
 });
})();